module.exports = __webpack_public_path__ + "static/media/Brenna P.93e7605c.jpeg";